import axios from 'axios'
import { encodeImageUrl } from '../../../features/common/Utilities'
import { setBottomRightInfo, sanitizeData } from './getAuto'
import { BFFAgent } from '../../BFFAgent'
import { CATALOGO_ENDPOINT } from 'common/endpoints'
const SIMILARS_ENDPOINT = CATALOGO_ENDPOINT + '/similars/'

export async function getSimilars(id, queryString, exchangeRate = []) {
  try {
    const similars = await axios.get(SIMILARS_ENDPOINT + id + '?' + queryString).then((res) => res.data.data)
    similars.forEach((similar) => {
      similar.image = encodeImageUrl(similar.image)
      similar.title = `${similar.brand} ${similar.model} ${similar.version}`
      sanitizeData(similar)
    })
  
    const { currencies, exchanges } = await BFFAgent.Datamasters.getCurrencies(exchangeRate);
    const defaultData = { symbol: '$', actualSellValue: 1, defaultCurrency: null, multiplier: 1 }
    
    similars.forEach(similar => {
      const hasExchange = exchanges.find(exchange => exchange.id === similar?.exchange_rate_id);
      const hasCurrency = currencies.find(currency => currency.id === hasExchange?.currency?.id);
      if (hasExchange && hasCurrency){
        similar.currency = { 
          ...hasCurrency, 
          multiplier: hasExchange.multiplier, 
          defaultCurrency: hasExchange.defaultCurrency 
        };
      } else {
        similar.currency = defaultData;
      }
    })
  
    return similars;
  } catch (error) {
    console.log(`Error getSimilars `, error);
    throw new Error(error);
  }

}

export async function getSimilarsComparador(id) {
  const similars = await getSimilars(id, 'limit=2&view=comparador')
  return similars
}

export async function getSimilarsVistaVendedor(id, car_lot_id, exchangeRate = []) {
  const similars = await getSimilars(id, `limit=10&view=vistavendedor&car_lot_id=${car_lot_id}`, exchangeRate)
  similars.forEach((auto) => {
    setBottomRightInfo(auto)
  })
  return similars
}
